<era-security-list-group-items-ui [groups]="memberGroups$ | async"
                                  [isEditing]="isEditing()"
                                  (deleteEvent)="delete($event)">
</era-security-list-group-items-ui>